export const capitalize = (phrase: string): string => {
  if (!phrase) return '';

  const capitalizedPhrase = phrase[0].toUpperCase() + phrase.slice(1);
  return capitalizedPhrase;
};
